import ModuleCenter from "../datamodule/ModuleCenter";
import { createRelDefaultOption, createRelDefaultListOption, getRelatedInfo } from "../datamodule/DataField";
import DictType from "../data/DictType";
import DataType from "../data/DataType";
import FieldRelation from "../datamodule/FieldRelation";
import FieldConfigs from "../datamodule/FieldConfigs";
import FieldType from "../datamodule/FieldType";
import ViewState from '../viewmodule/ViewState';

const copyDatas = (datas)=> {
    if (!datas) return [];
    const result = [];
    for (const data of datas) {
        result.push(Object.assign({}, data));
    }
    return result;
}
const getDataValue = (data, field)=> {
    return data[field];
}
const getDatasValues = (datas, field)=> {
    const values = [];
    const map = {};
    for (const data of datas) {
        const value = getDataValue(data, field);
        if (value == null) continue;
        if (value instanceof Array) {
            for (const v of value) {
                if (!map[v]) {
                    map[v] = 1;
                    values.push(v);
                }
            }
        } else {
            if (!map[value]) {
                map[value] = 1;
                values.push(value);
            }
        }
    }
    return values;
}

const fillLocalDatas = async(datas, path)=> {
    if (path.length <= 1) return datas;
    let relInfo = path.shift();
    const module = relInfo.module;
    const dataField = relInfo.field;
    const values = getDatasValues(datas, dataField.getCode());

    let rDatas = null;
    relInfo = path[0];
    let rModule = relInfo.module;
    let relField = relInfo.relField;
    if (dataField.isForeignKey()) {
        relInfo = dataField.getRelatedInfo();
        rDatas = await relInfo.module.getByKeys(values, relInfo.field.getCode());
        // await rInfo.module.getByKeys(values);
    } else {
        const rField = relField ? rModule.getDataField(relField) : rModule.getForeignField(module.getCode() + '.' + dataField.getCode());
        rDatas = await rModule.getByFKeys(values, rField.getCode());
    }
    if (path.length > 1) {
        return await fillLocalDatas(rDatas, path);
    } else {
        return rDatas;
    }
}

const fillData = (data, field, path, fixed)=> {
    if (!path.length) return data;
    let multi = false;
    let datas = [data];
    let relInfo = path[0];
    let module = relInfo.module;
    let dataField = relInfo.field;
    let values = getDatasValues(datas, dataField.getCode());
    for (let i = 1; i < path.length; i++) {
        relInfo = path[i];
        if (dataField.isForeignKey()) {
            const rInfo = dataField.getRelatedInfo();
            datas = rInfo.module.getByKeysLocal(values, rInfo.field.getCode());
            if (rInfo.rs == FieldRelation.FR_1vN) multi = true;
        } else {
            const rField = relInfo.relField ? relInfo.module.getDataField(relInfo.relField) : relInfo.module.getForeignField(module.getCode() + '.' + dataField.getCode());
            const rInfo = rField.getRelatedInfo();
            datas = relInfo.module.getByFKeysLocal(values, rField.getCode());
            if (rInfo.rs == FieldRelation.FR_Mv1) multi = true;
        }
        dataField = relInfo.field;
        module = relInfo.module;
        if (!fixed && i == path.length - 1) {
            // values = module.datasKeys(datas);
        } else values = getDatasValues(datas, dataField.getCode());
        if (!multi && values && values.length) values = [values[0]];
    }
    if (!multi) {
        if (values && values.length) values = values[0];
        else values = null;
    }
    data[field] = values;
}

const updateFieldOptions = (field, relInfo, keyField, datas)=> {
    if (field.dataOptions && relInfo.module.getModuleType() == DictType.STATIC) return;
    field.targetField = keyField;
    field.targetModule = relInfo.module.getCode();
    field.dataOptions = relInfo.module.getDataOptions(datas, relInfo.field.getCode(), keyField);
    // console.log('update field options', field.field, field.dataOptions);
}

class DataView {
    _code = null;
    _module = null;
    _defaultFields = null;
    // _viewFields = null;
    // _listFields = null;

    constructor(config) {
        this._config = config;
        this._code = config.code;
        this._module = config.module ? ModuleCenter.getModule(config.module) : this.createModuleByConfig(config);
        // this.setFields(config.fields);
        this._defaultFields = this.formatViewFields(config.fields);
    }
    createModuleByConfig(config) {
        const moduleFields = [];
        const fieldConfigs = config.fields;
        for (const fieldConfig of fieldConfigs) {
            const {name, field, rel} = fieldConfig;
            const moduleField = {name, code:field, rel};
            moduleFields.push(moduleField);
        }
        const moduleConfig = {fields:moduleFields};
        return ModuleCenter.registerModule(moduleConfig);
    }
    getCode() {
        return this._code;
    }
    getModule() {
        return this._module;
    }
    getModuleCode() {
        return this._config?.module || this._module.getCode();
    }
    getDataField(field) {
        return this._module.getDataField(field);
    }
    getSummaryFields() {
        const fields = [];
        const fs = this.getTableFields();
        for (const f of fs) {
            if (f.summary) fields.push(f.field);
        }
        return fields.concat(this._module.getSummaryFields());
    }
    
    defaultKeyField() {
        return this._module.defaultKeyField();
    }
    dataKey(data, keyField) {
        return this._module.dataKey(data, keyField);
    }
    datasKeys(datas, keyField) {
        return this._module.datasKeys(datas, keyField);
    }
    keyFields() {
        return this._module.keyFields();
    }
    getData(key, keyField) {
        return this._module.getDataLocal(key, keyField);
    }
    getDatas(keys, keyField) {
        return this._module.getDatasLocal(keys, keyField);
    }
    getListFields() {
        // return this._listFields;
        return null;
    }
    getMappedKeyData(data, relModule, field) {
        return this._module.getMappedKeyData(data, relModule, field);
    }
    formatViewFields(fields) {
        const viewFields = [];
        for (let field of fields) {
            if (!field) {
                viewFields.push(null);
                continue;
            }
            if (!(field instanceof Object)) field = {field:field};
            // let subFields = null;
            if (field.subFields) {
                field.subFields = this.formatViewFields(field.subFields);
            }
            const dataField = this._module?.getDataField(field.field);
            const viewField = Object.assign({name:dataField?.getName(), dataType:dataField?.getDataType() || field.type, sortable:dataField?.getSortable(), sort:dataField?.getSort()}, field);
            let path = null;
            if (field.relPath || field.srcField) {
                path = [];
                const relPath = field.relPath || [];
                const df = this._module?.getDataField(field.srcField || field.field);
                if (df && (relPath.length != 1 || relPath[0] != df.getForeignField())) {
                    for (const rel of relPath) {
                        path.push(getRelatedInfo(rel));
                    }
                    path.unshift({module:this._module, field:df});
                    const extInfo = this.getPathExtInfo(path);
                    viewField.path = path;
                    viewField.multiple = extInfo.multiple;
                    viewField.static = extInfo.static;
                    viewField.tree = extInfo.tree;

                }
            }
            viewFields.push(viewField);
        }
        return viewFields;
    }
    getTableFields() {
        if (this._tableFields) return this._tableFields;
        const fields = [];
        for (const viewField of this._defaultFields) {
            let field = Object.assign({}, viewField);
            if (field.path) {
                const def = {};
                if (field.static && field.type != 'link') {
                    def.width = 140;
                    def.align = 'center';
                }
                field = Object.assign(def, field.multiple ? FieldConfigs.TAG : FieldConfigs.LABEL, field);
            } else if (field.type == 'detail') {
                field = Object.assign({}, FieldConfigs.DETAIL, field);
            } else if (field.dataType == 'date' || field.dataType == 'time' || field.dataType == 'datetime') {
                field = Object.assign({align:'right'}, FieldConfigs.LABEL, field);
            } else if (field.dataType == 'number') {
                field = Object.assign({align:'right'}, FieldConfigs.LABEL, field);
            } else if (field.dataType == 'currency') {
                field = Object.assign({precision:2, align:'right'}, FieldConfigs.LABEL, field);
            }  else {
                field = Object.assign({}, FieldConfigs.LABEL, field);
            }
            fields.push(field);
        }
        return this._tableFields = fields;
    }
    getFormFields() {
        if (this._formFields) return this._formFields;
        const fields = [];
        for (const viewField of this._defaultFields) {
            let field = Object.assign({}, viewField);
            if (!viewField) {
                field = Object.assign({}, FieldConfigs.getDataTypeConfig(null));
            } else if (field.path) {
                if (field.tree) {
                    field = Object.assign({}, FieldConfigs.CASCADE, field);
                } else {
                    const v = (field.multiple ? 2 : 0) | (field.static ? 1 : 0);
                    switch (v) {
                        case 0: field = Object.assign({}, FieldConfigs.SELECTION, field); break;
                        case 1: field = Object.assign({}, FieldConfigs.SELECT, field); break;
                        case 2: field = Object.assign({}, FieldConfigs.MULTISELECTION, field); break;
                        case 3: field = Object.assign({}, FieldConfigs.MULTISELECT, field); break;
                    }
                }
            } else {
                field = Object.assign({}, FieldConfigs.getDataTypeConfig(field.dataType || DataType.STRING), field);
            }
            fields.push(field);
        }
        return this._formFields = fields;
    }
    getQueryFields() {
        if (this._queryFields) return this._queryFields;
        const fields = [];
        for (const viewField of this._defaultFields) {
            let field = Object.assign({}, viewField);
            if (field.path) {
                if (field.tree) {
                    field = Object.assign({}, FieldConfigs.CASCADE, field);
                } else {
                    const v = (field.multiple ? 2 : 0) | (field.static ? 1 : 0);
                    switch (v) {
                        case 0: field = Object.assign({}, FieldConfigs.SELECTION, field); break;
                        case 1: field = Object.assign({}, FieldConfigs.SELECT, field); break;
                        case 2: field = Object.assign({}, FieldConfigs.MULTISELECTION, field); break;
                        case 3: field = Object.assign({}, FieldConfigs.MULTISELECT, field); break;
                    }
                }
            } else {
                if (field.dataType == DataType.TEXT) field = Object.assign({}, FieldConfigs.INPUT, field);
                else field = Object.assign({}, FieldConfigs.getDataTypeConfig(field.dataType || DataType.STRING), field);
            }
            fields.push(field);
        }
        return this._queryFields = fields;
    }
    getViewFields() {
        if (this._viewFields) return this._viewFields;
        const fields = [];
        for (const viewField of this._defaultFields) {
            let field = Object.assign({}, viewField);
            if (field.path) {
                field = Object.assign({}, field.multiple ? FieldConfigs.TAG : FieldConfigs.LABEL, field);
            } else if (field.type == 'detail') {
                field = Object.assign({}, FieldConfigs.DETAIL, field);
            } else if (field.dataType == 'currency') {
                field = Object.assign({precision:2}, FieldConfigs.LABEL, field);
            }  else {
                field = Object.assign({}, FieldConfigs.LABEL, field);
            }
            fields.push(field);
        }
        return this._viewFields = fields;
    }

    getTableFieldOptions(data) {
        const fields = this.getTableFields();
        const options = {};
        for (const tableField of fields) {
            if (tableField.dataOptions) {
                const field = tableField.field;
                options[field] = null;
                const value = data[field];
                const d = tableField.dataOptions.dataInfo.getDataLocal(value, tableField.dataOptions.keyField);
                if (d) options[field] = d[tableField.dataOptions.nameField];
                // for (const opt of tableField.dataOptions) {
                //     if (opt.value == value) {
                //         options[field] = opt.label;
                //     }
                // }
            }
        }
        return options;
    }

    // setFields(fields) {
    //     const viewFields = [];
    //     const listFields = [];
    //     for (const field of fields) {
    //         let viewField = null;
    //         let listField = null;
    //         let dataField = null;
            
    //         let path = null;
    //         let extInfo = null;
    //         if (field.relPath || field.srcField) {
    //             if (field.isBusinessField) {
    //                 const relPath = field.relPath || [];

    //             } else {
    //                 path = [];
    //                 const relPath = field.relPath || [];
    //                 for (const rel of relPath) {
    //                     path.push(getRelatedInfo(rel));
    //                 }
    //                 path.unshift({module:this._module, field:this._module.getDataField(field.srcField || field.field)});
    //                 // listField.path = viewField.path = path;
    //                 extInfo = this.getPathExtInfo(path);

    //                 // listField.multiple = viewField.multiple = extInfo.multiple;
    //                 // listField.static = viewField.static = extInfo.static;

    //                 // if (extInfo.multiple) listField.type = FieldType.TAG;
    //             }
    //         }
            
    //         if (field instanceof Object) {
    //             dataField = this._module.getDataField(field.field);
    //             if (dataField) {
    //                 if (path) dataField.resetRelDefaultOptions(extInfo.multiple, extInfo.static);
    //                 viewField = Object.assign({}, dataField.getDefaultOption(), field);
    //                 listField = Object.assign({}, dataField.getDefaultListOption(), field);
    //                 if (path) listField.path = viewField.path = path;
    //             } else {
    //                 let viewData = FieldConfigs.getConfig(field.type) || {};
    //                 let listData = FieldConfigs.getConfig(field.type) || {};
    //                 if (path) {
    //                     viewData = createRelDefaultOption(field, extInfo.multiple, extInfo.static, null);
    //                     listData = createRelDefaultListOption(field, extInfo.multiple, extInfo.static, null);
    //                 }
    //                 viewField = Object.assign({}, viewData, field);
    //                 listField = Object.assign({}, listData, field);
    //                 if (path) listField.path = viewField.path = path;
    //             }
    //         } else {
    //             dataField = this._module.getDataField(field);
    //             if (dataField) {
    //                 if (path) dataField.resetRelDefaultOptions(extInfo.multiple, extInfo.static);
    //                 viewField = Object.assign({}, dataField.getDefaultOption());
    //                 listField = Object.assign({}, dataField.getDefaultListOption());
    //                 if (path) listField.path = viewField.path = path;
    //             } else {
    //                 let viewData = {};
    //                 let listData = {};
    //                 if (path) {
    //                     viewData = createRelDefaultOption({field:field, name:field}, extInfo.multiple, extInfo.static, null);
    //                     listData = createRelDefaultListOption({field:field, name:field}, extInfo.multiple, extInfo.static, null);
    //                 }
    //                 viewField = Object.assign({}, viewData);
    //                 listField = Object.assign({}, listData);
    //                 if (path) {
    //                     listField.path = viewField.path = path;
    //                 }
    //             }
    //         }
    //         viewFields.push(viewField);
    //         listFields.push(listField);
    //     }
    //     this._viewFields = viewFields;
    //     this._listFields = listFields;
    // }
    getPathExtInfo(path) {
        const info = {multiple:false, tree:false, static:path[path.length - 1].module.getModuleType() == DictType.STATIC};
        let relInfo = path[0];
        let module = relInfo.module;
        let dataField = relInfo.field;
        for (let i = 1; i < path.length; i++) {
            relInfo = path[i];
            if (dataField.isForeignKey()) {
                const rInfo = dataField.getRelatedInfo();
                if (rInfo.field._tree) info.tree = true;
                if (rInfo.rs == FieldRelation.FR_1vN) info.multiple = true;
            } else {
                const rField = relInfo.module.getForeignField(module.getCode() + '.' + dataField.getCode());
                const rInfo = rField.getRelatedInfo();
                if (rInfo.field._tree) info.tree = true;
                if (rInfo.rs == FieldRelation.FR_Mv1) info.multiple = true;
            }
            dataField = relInfo.field;
            module = relInfo.module;
        }
        return info;
    }
    getByKeysLocal(keys, keyField) {
        return this._module.getByKeysLocal(keys, keyField);
    }
    async getByKey(key, keyField) {
        return this._module.getByKey(key, keyField);
    }
    async getByKeys(keys, keyField) {
        return this._module.getByKeys(keys, keyField);
    }
    async queryDatas(queryParams, keyData, pagination, extData) {
        const data = await this._module.queryDatas(queryParams, keyData, pagination, extData);
        if (!data) return;
        const datas = await this.fillDatas(data);
        return {data:datas, pagination:pagination};
    }
    async queryDatasWithUrl(url, queryParams, keyData, pagination, extData) {
        const data = await this._module.queryDatasWithUrl(url, queryParams, keyData, pagination, extData);
        const datas = await this.fillDatas(data);
        return {data:datas, pagination:pagination};
    }
    async fillDatas(oriDatas) {
        if (!oriDatas || !oriDatas.length) return [];
        const fillField = (field, datas)=> {
            if (field.path) {
                const path = field.path.slice();
                ps.push(fillLocalDatas(datas, path).then((fullDatas)=> {
                    updateFieldOptions(field, field.path[field.path.length - 1], field.path[field.path.length - 2].field._relFieldCode, fullDatas);
                    
                    // 如果 field 是外键，并且path长度为 2 时，就不需要填充数据
                    const targetField = this._module.getDataField(field.srcField || field.field);
                    if (!field.srcField && targetField && targetField.isForeignKey() && path.length <= 2) {
                    } else {
                        for (const data of datas) {
                            fillData(data, field.field, field.path, field.fixed);
                        }
                    }
                }));
            }
        }
        const datas = copyDatas(oriDatas);
        const ps = [];
        for (const field of this.getTableFields()) {
            if (field.subFields) {
                for (const f of field.subFields) {
                    fillField(f, datas);
                }
            } else {
                fillField(field, datas);
            }
        }
        await Promise.all(ps);
        // console.log('table fields', this.getTableFields());
        return datas;
    }
    async loadData(keyData, viewState) {
        const key = this._module.dataKey(keyData);
        const oriData = await this._module.getData(key);
        return this.fillData(oriData, viewState);
    }
    async loadDataWithUrl(url, keyData, viewState) {
        const key = this._module.dataKey(keyData);
        const oriData = await this._module.getDataWithUrl(url, key);
        return this.fillData(oriData, viewState);
    }
    async fillData(oriData, viewState) {
        const fillField = (field, data)=> {
            if (field.path) {
                const path = field.path.slice();
                ps.push(fillLocalDatas([data], path).then((fullDatas)=> {
                    updateFieldOptions(field, field.path[field.path.length - 1], field.path[field.path.length - 2].field._relFieldCode, fullDatas);

                    const targetField = this._module.getDataField(field.srcField || field.field);
                    if (!field.srcField && targetField && targetField.isForeignKey() && path.length <= 2) {
                    } else {
                        fillData(data, field.field, field.path, field.fixed);
                    }
                }))
            }
        }
        const data = Object.assign({}, oriData);
        let fields = null;
        switch (viewState) {
            case ViewState.QUERY: fields = this.getQueryFields(); break;
            case ViewState.CREATE:
            case ViewState.EDIT: fields = this.getFormFields(); break;
            default:
            case ViewState.VIEW: fields = this.getViewFields(); break;
        }
        // const fields = (viewState == ViewState.EDIT || viewState == ViewState.CREATE) ? this.getFormFields() : this.getViewFields();
        const ps = [];
        for (const field of fields) {
            if (field.subFields) {
                for (const f of field.subFields) {
                    fillField(f, data);
                }
            } else {
                fillField(field, data);
            }
        }
        await Promise.all(ps);
        return data;
    }
    async saveData(data) {
        const key = this._module.dataKey(data);
        if (key == null) {
            return this._module.createData(data);
        } else {
            return this._module.editData(key, data);
        }
    }
    async saveDatas(datas) {
        return this._module.editDatas(datas);
    }
    async saveDataWithUrl(url, data) {
        const key = this._module.dataKey(data);
        if (key == null) {
            return this._module.createDataWithUrl(url, data);
        } else {
            return this._module.editDataWithUrl(url, key, data);
        }
    }
    async createDatas(datas) {
        return this._module.createDatas(datas);
    }

    async deleteDatas(datas) {
        let keys = this.datasKeys(datas,'id');
        if (keys[0] == null)
        keys = this.datasKeys(datas);
        return this._module.deleteDatasByKeys(keys);
    }

    async do(url, data, type) {
        return this._module.simpleCall(url, data, type);
    }

    async getNextData(data, filter) {
        return this._module.getNextData(data, filter);
    }

    compareData(oriData, destData) {
        if (!oriData && !destData) return true;
        if (!oriData || !destData) return false;
        const fields = this.getFormFields();
        for (const field of fields) {
            const f = field.field;
            if (oriData[f] != destData[f]) return false;
        }
        return true;
    }
}

export default DataView;